import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';

const TextBorderedBoxes = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <Row className='row-cols-lg-3 g-3 mb-5'>
            {list.map((item, index) => (
              <div key={index} className='d-flex'>
                <div className='bg-white flex-fill p-3 py-5 border border-2 rounded-3 border-dark-grey-4'>
                  {(item.showTitle && item.title) && <Heading type='h3' className='mb-3'>{item.title}</Heading>}
                  {item.text && <RichText json={item.text}/>}
                </div>
              </div>
            ))}
          </Row>
        }
      </Container>
    </Section>
  )
}

export default TextBorderedBoxes
